import { LoginPage } from "@pages/auth/Login";
import { ForgotPassword } from "@pages/auth/ForgotPassword";
import { AuthChallenge } from "@pages/auth/AuthChallenge";
import { Logout } from "@pages/auth/Logout";
import { SsoCallbackPage } from "@pages/auth/SsoCallbackPage";
import { AdminImpersonateCallbackPage } from "@pages/auth/AdminImpersonateCallbackPage";
import { AppRoute } from "./types";

export const authRoutes: AppRoute[] = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/login/sso",
    element: <LoginPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/auth-challenge/new-password-required",
    element: <AuthChallenge />,
  },
  {
    path: "/logout",
    element: <Logout />,
    protected: true,
  },
  {
    path: "/sso/callback",
    element: <SsoCallbackPage />,
  },
  {
    path: "/admin-impersonate/callback",
    element: <AdminImpersonateCallbackPage />,
  },
];
